import { Component } from '@angular/core';
import {Modal} from "../modal";
import {ModalController} from "@ionic/angular";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {PickedFile} from "@capawesome/capacitor-file-picker";
import {DocumentFile} from "../../models/models";

@Component({
  selector: 'app-bank-informations',
  templateUrl: './bank-informations.component.html',
  styleUrls: ['./bank-informations.component.scss'],
})
export class BankInformationsComponent extends Modal {
  bankInformationsForm: FormGroup;

  constructor(
    modalCtrl: ModalController,
    private formBuilder: FormBuilder
  ) {
    super(modalCtrl);
  }

  override ngOnInit() {
    super.ngOnInit();
    this.bankInformationsForm = this.formBuilder.group({
      file: new FormControl(null, [Validators.required])
    });
  }

  addFiles(files: PickedFile[]) {
    for (const f of files) {
      this.bankInformationsForm.value.file = files[0];
    }
  }

  removeFile() {
    this.bankInformationsForm.controls['file'].setValue(null);
  }
}
